import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "top-card-material",
  templateUrl: "./top-card-material.component.html",
  styleUrls: ["./top-card-material.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TopCardMaterialComponent {
  @Input() cardConfig: any;
  @Input() creation: boolean;
  @Input() duplication: boolean;
  @Input() current: any;
  @Input() icon: any;
  @Input() image: any;

  @Input() canDuplicate?: boolean = true;
  @Input() canNew?: boolean = true;
  @Input() canUpdate?: boolean = true;
  @Input() canRefresh?: boolean = true;
  @Input() canMultipleSave?: boolean = false;
  @Input() multipleSaveOptions?: { primary: string; secondary: string[] };

  @Output() public backData: EventEmitter<any> = new EventEmitter();
  @Output() public refreshData: EventEmitter<any> = new EventEmitter();
  @Output() public duplicateData: EventEmitter<any> = new EventEmitter();
  @Output() public newData: EventEmitter<any> = new EventEmitter();
  @Output() public submitData: EventEmitter<any> = new EventEmitter();
  @Output() public submitDataFromMultiplePrimary: EventEmitter<any> = new EventEmitter();
  @Output() public submitDataFromMultipleSecondary: EventEmitter<any> = new EventEmitter();

  constructor(private translate: TranslateService) {}

  back() {
    this.backData.emit();
  }

  refresh() {
    this.refreshData.emit();
  }

  duplicate() {
    this.duplicateData.emit();
  }

  create() {
    this.newData.emit();
  }

  submit() {
    this.submitData.emit();
  }

  multipleOptionPrimarySubmited() {
    this.submitDataFromMultiplePrimary.emit();
  }

  multipleOptionSecondarySubmited(index: number) {
    this.submitDataFromMultipleSecondary.emit(index);
  }
}
